import {ApplicationEntity} from "@/model/entity/application-entity"
import {Exclude} from "class-transformer"

export class Country extends ApplicationEntity {
  countryCode: number

  name: string

  countryHomeName: string

  countryStringCode: string

  currency: string

  isoCodeAlpha2: string

  isoCodeAlpha3: string

  isoCodeNumeric: string

  crEnabled: boolean

  currencyHasDecimals: boolean

  eu: boolean

  isDpdCountry: boolean

  dswCountryCode: number

  @Exclude()
  i18nKey: string

  restricted: boolean

  constructor(
    id: number,
    countryCode: number,
    countryName: string,
    countryHomeName: string,
    countryStringCode: string,
    currency: string,
    isoCodeAlpha2: string,
    isoCodeAlpha3: string,
    isoCodeNumeric: string,
    crEnabled: boolean,
    currencyHasDecimals: boolean,
    eu: boolean,
    isDpdCountry: boolean,
    dswCountryCode: number,
    i18nKey: string,
    restricted: boolean
  ) {
    super(id)
    this.countryCode = countryCode
    this.name = countryName
    this.countryHomeName = countryHomeName
    this.countryStringCode = countryStringCode
    this.currency = currency
    this.isoCodeAlpha2 = isoCodeAlpha2
    this.isoCodeAlpha3 = isoCodeAlpha3
    this.isoCodeNumeric = isoCodeNumeric
    this.crEnabled = crEnabled
    this.currencyHasDecimals = currencyHasDecimals
    this.eu = eu
    this.isDpdCountry = isDpdCountry
    this.dswCountryCode = dswCountryCode
    this.i18nKey = i18nKey
    this.restricted = restricted || false
  }
}
